export class SeedEntity {
  id: number = null as any;
  gmtCreate: number = 0;
  gmtModify: number = 0;
  isDelete: boolean = false;
}
